/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-03 10:19
 * @LastEditors: wenbin.ma@ginlong.com
 * @LastEditTime: 2026-09-03 16:48
 * @FilePath: \glyun_web_vue3\src\stores\user.js
 * @Description: 状态管理器-用户信息
 */
import { defineStore } from 'pinia'
// import dayjs from 'dayjs'
import { useSystemConfigStore } from './system';
import { switchUiVersions } from '@/utils/changeSystem/index.js'
import { cloneDeep } from 'lodash-es'
import router from '@/router'
import { handleIsNewVersionPath } from '@/utils/postMessge/toggleVersion';
import { sanitizeUserInfo } from '@/utils/userInfo'

const cookieType = import.meta.env.VITE_COOKIE_TYPE

console.log("行号: 16", JSON.parse(localStorage.getItem('userInfo'))?.useNew)
console.log("行号: 17", JSON.parse(localStorage.getItem('userInfo'))?.useNew ?? 1)
export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {
      // 用户信息
      id: "",
      userName: "",// 用户名
      userType: "",//
      photoUrl: '', // 头像
      apiShowSwitch: 0, //是否开通api权限0: 关,1: 开
      sdkSwitch: 0, //是否有SDK接入菜单权限0: 关,1: 开
      functionIds: '', // 功能权限
      timeFormat: "yyyy-MM-dd",
      yearMongthFormat: "yyyy-MM",
      yearFormat: "yyyy",
      offlineTime: "",
      email: "",
      mobile: "",
      timeZone: "",// 用户时区
      // userTimeZone: "",// 用户时区
      upgradeAuthorization: undefined,// 用户是否点击过 自固件动升级免责协议弹框
      useNew: JSON.parse(localStorage.getItem('userInfo'))?.useNew ?? 1, // 版本切换显示 1: 新版本, 0: 旧版本
      showSwitchVersionButton: false, // 是否显示切换新老版本按钮
      themeColor:localStorage.getItem('themeColor') || "#F08519", //主题颜色
      logoUrl: "",// 网站LOGO(左侧菜单导航顶部)
      iconUrl: "",// 网站标签页ico
      orgType: 1, // 1-非内部账号，2-内部账号
      survey: {
        surveySwitch: 0,// 0=关，1=开
        surveyUrlWeb: "",
        picUrl: "",
        name: "",
      },
    },
    // token: '', // 认证令牌
    isLoggedIn: false, // 登录状态
    isDark: false,
    // switchAccountsFlag: true,// 切换账号变更不弹token变更
    dot: {// 红点
      maintenance: false,// 运维(一级菜单)
      alarm: false,// 报警(二级菜单)
      deviceManagement: false,// 设备管理(二级菜单)
      discoverDot: false,// 服务 - 发现(二级菜单)
      noticeDot: false,// 消息 - 系统通知
    },
    systemNoticeDot: false,// 消息 - 系统通知
    storeRoutes: {} ,// 存储一份路由数据
    childRouteData: null, // 子应用路由数据
  }),
  // 启用持久化
  persist: true,

  getters: {
    // 获取用户姓名
    userName: (state) => state.userInfo?.userName || '',
    // 获取用户类型
    userType: (state) => state.userInfo?.userType || '',
    // 判断是否已登录
    // hasToken: (state) => !!state.token,
    // 获取权限列表
    functionIdsArr: (state) => state.userInfo?.functionIds?.split(',') || [],
    timeFormat: (state) => (state.userInfo?.timeFormat)?.toUpperCase() || "yyyy-MM-dd", //用户月年时间格式
    yearMongthFormat: (state) => (state.userInfo?.yearMongthFormat)?.toUpperCase() || "yyyy-MM", //用户年时间格式
    yearFormat: (state) => (state.userInfo?.yearFormat)?.toUpperCase() || "yyyy", //用户年时间格式
    offlineTime: (state) => state.userInfo?.offlineTime, // 异常离线时间 // 设备异常离线时间
    email: (state) => state.userInfo?.email || '', //用户邮箱
    mobile: (state) => state.userInfo?.mobile || '', //用户手机号
    userId: (state) => state.userInfo?.id || '', //用户id
    isInternalAccount: (state) => Number(state.userInfo?.accountType) === 2, //是否是内部账号 0: 业主,1: 安装商,2: 内部账号
  },

  actions: {
    // 登录并保存用户信息
    login(userData,isReload) {
      const oldUserInfo = cloneDeep(this.userInfo)
      this.userInfo = sanitizeUserInfo({...userData.data})
      console.log("🚀 ~ login ~ userData.data:", userData.data)
      console.log('行号: 98', typeof cookieType, cookieType)
      if (cookieType === '1') {
        // 使用cookie-only后无需储存
        this.token = userData.csrfToken
        // 持久化存储（可选）
        // 使用cookie-only后无需储存
        localStorage.setItem('token', userData.csrfToken)
      }

      this.isLoggedIn = true
      const newUserInfo = cloneDeep(userData.data)
      // const oldUserInfo = cloneDeep(this.userInfo)
      this.updateConfig(newUserInfo,oldUserInfo,isReload)
      // this.updateConfig(newUserInfo)
      // 持久化存储（可选）
      localStorage.setItem('userInfo', JSON.stringify(sanitizeUserInfo(userData.data)))
    },
    switchAccounts({ csrfToken, data }){
      this.login({
        csrfToken,
        data,
      },true)
    },
    // updateSwitchAccountsFlag(switchAccountsFlag){
    //   this.switchAccountsFlag = switchAccountsFlag
    // },
    // 退出登录
    logout() {
      console.log("行号: 121 存在退出")
      this.$reset()
      // this.userInfo = {
      //   id: "",
      //   userName: "",// 用户名
      //   userType: "",//
      //   photoUrl: '', // 头像
      //   apiShowSwitch: 0, //是否开通api权限0: 关,1: 开
      //   sdkSwitch: 0, //是否有SDK接入菜单权限0: 关,1: 开
      //   functionIds: '', // 功能权限
      //   timeFormat: "yyyy-MM-dd",
      //   yearMongthFormat: "yyyy-MM",
      //   yearFormat: "yyyy",
      //   offlineTime: "",
      //   email: "",
      //   mobile: "",
      //   timeZone: "",// 用户时区
      //   upgradeAuthorization: undefined,// 用户是否点击过 自固件动升级免责协议弹框
      //   useNew: 1, // 版本切换显示 true: 新版本, false: 旧版本
      //   showSwitchVersionButton: false, // 版本切换按钮是否显示
      //   themeColor:localStorage.getItem('themeColor') || "#F08519", //主题颜色
      //   logoUrl: "",// 网站LOGO(左侧菜单导航顶部)
      //   iconUrl: "",// 网站标签页ico
      //   orgType: 1, // 1-非内部账号，2-内部账号
      //   survey: {
      //     surveySwitch: 0,// 0=关，1=开
      //     surveyUrlWeb: "",
      //     picUrl: "",
      //     name: "",
      //   },
      // }
      // if (cookieType === '1') {
      //   this.token = ""
      // }
      // this.isLoggedIn = false

      // 清除本地存储
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('netPurchase') // 净买电
      sessionStorage.removeItem('verificationCode')
      router.push("/login")
    },

    // 更新用户信息
    updateUserInfo(newInfo) {
      const newUserInfo = cloneDeep(newInfo)
      const oldUserInfo = cloneDeep(this.userInfo)
      this.userInfo = sanitizeUserInfo({ ...this.userInfo, ...newUserInfo })
      localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
      this.updateConfig(this.userInfo, oldUserInfo)
    },
    // 设置切换新版子应用数据
    setChildRouteData(data) {
      this.childRouteData = data || null
    },
    // // 设置UI版本
    // setUiVersion(value) {
    //   this.useNew = value
    // },
    setIsDark(value) {
      this.isDark = value
    },
    updateConfig(userInfo, oldUserInfo,isReload){
      console.log("🚀 ~ updateConfig ~ 配置:", userInfo,)
      const systemConfigStore = useSystemConfigStore()
      const odmConfig = systemConfigStore.defaultConfig?.odmConfig

      console.log("🚀 ~ updateConfig ~ systemConfigStore:", systemConfigStore,systemConfigStore.defaultConfig)
      // 修改logo
      // if(userInfo.logoUrl){
        console.log("🚀 ~ 修改logoUrl:", userInfo?.logoUrl)
        systemConfigStore.updateSystemConfig({
          odmConfig: {
            infoLogo: userInfo?.logoUrl || odmConfig?.infoLogo,
          }
        })
      // }
      // 修改ico
      console.log("🚀 ~ 修改ico:", userInfo?.iconUrl)
      // if(userInfo?.iconUrl){
        console.log("🚀 ~ 修改ico:", userInfo?.iconUrl)
        systemConfigStore.updateSystemConfig({
          odmConfig: {
            iconLogo: userInfo?.iconUrl || odmConfig?.iconLogo,
          }
        })
      // }


      // 修改主题色
      console.log("🚀 ~ 修改主题色:", userInfo?.themeColor)
      if(userInfo?.themeColor){
        console.log("🚀 ~ 修改主题色:", userInfo?.themeColor)
        systemConfigStore.updateSystemConfig({
          odmConfig: {
            themeColor: userInfo?.themeColor
          }
        })
      }
      // 修改语言
      console.log("🚀 ~ 修改语言:", userInfo?.language)
      if(userInfo?.language && (userInfo?.language !== oldUserInfo?.language)){
        console.log("🚀 ~ 修改语言:", userInfo?.language)
        systemConfigStore.updateLang(userInfo?.language)
      }
      console.log('routersssss',useRoute())
      // 修改新旧版本
      console.log("🚀 ~ 修改新旧版本:", userInfo?.useNew, oldUserInfo)
      if(userInfo?.useNew !== undefined && (userInfo?.useNew !== oldUserInfo?.useNew)){
        // const router = useRouter()
        console.log("🚀 ~ 修改新旧版本:", userInfo.useNew, switchUiVersions)
        switchUiVersions(userInfo?.useNew, this.childRouteData)
          .then(() => {
            this.childRouteData = null
          })
      }
      if (isReload) {
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    },
    // 更新红点状态状态
    updateDot(data){
      const newData = cloneDeep(data)
      this.dot = { ...this.dot, ...newData }
    },
    // 更新系统通知红点状态
    updateNoticeDot(data){
      this.systemNoticeDot = data
    },
    // 更新路由
    updateStoreRoutes(data) {
      this.storeRoutes = data
    },
    // 更新uiStyle
    updateUiStyle(data) {
      this.userInfo.uiStyle = data;
      localStorage.setItem('userInfo', JSON.stringify(sanitizeUserInfo(this.userInfo)))
    }
  },
})
